import {Board, Question} from "../javaTypes";

export default function QuestionNumber({board, question}: {
    board: Board,
    question: Question
}) {
    // bootstrap-alert colorings
    return (<span style={{background: 'var(--bs-primary-bg-subtle)', color: 'var(--bs-primary-text-emphasis)', border: '1px solid var(--bs-primary-border-subtle)', paddingLeft: '.2em', paddingRight: '.2em' }}>{board.slug.toUpperCase()}{question?.number}</span>)
}